import React from 'react'
import { Typography } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import { useIsOnline } from 'commons/useIsOnline'
import NetworkError from 'app/components/NetworkError'
import ContentToolbarPage from 'app/components/ContentToolbarPage'
import LargeToolbar from 'app/components/LargeToolbar'
import ProfileInfoTabs from 'app/main/profile/ProfileInfoTabs'
import QrButton from 'app/main/profile/components/QrButton'
import { usePlace } from 'commons/usePlace'
import TogglePlacePublic from 'app/main/profile/components/TogglePlacePublic'
import { isNil } from 'ramda'
import { useFlag } from '@unleash/proxy-client-react'
import ProfileV4 from './ProfileV4'

export default () => {
  const [isOnline] = useIsOnline()
  const place = usePlace()
  const mes_3908_place_profile = useFlag('mes_3908_place_profile')

  if (!isOnline) {
    return <NetworkError />
  }

  if (mes_3908_place_profile) return <ProfileV4 />

  return (
    <ContentToolbarPage
      isFitViewPort
      contentToolbar={
        <>
          <LargeToolbar
            content={
              <>
                <Typography variant="h6">
                  <FormattedMessage id="navigation.profile.profileInfo.label" />
                </Typography>
              </>
            }
          />
          <div className="flex mx-20 items-center">
            <TogglePlacePublic />
            {isNil(place?.info?.description) ||
            isNil(place?.info?.logo) ? null : (
              <QrButton placeName={place.name} />
            )}
          </div>
        </>
      }
      content={
        <>
          <ProfileInfoTabs />
        </>
      }
      isFullContainer={true}
    />
  )
}
